<template>
  <PageHeaderLayout v-show='this.$route.matched.length===2'>

    <div class='main-page-content'>
      <el-card class='box-card' shadow='never'>
        <!-- 头部：清空 / 标题(在线数) / 刷新 / WS状态 / 订阅开关 -->
        <div class='header'>
          <el-button :loading='refreshing' icon='el-icon-refresh' type='text' @click='refreshOnline'>刷新</el-button>
          <span class='header-title'>
            实时在线人员名单
            <el-tag size='small' type='danger' effect='dark'>{{ lineArray.length }} 人在线</el-tag>
          </span>
          <el-button icon='el-icon-delete' type='text' @click='forceClear'>清空</el-button>
          <el-checkbox v-model='subStatus' @change='subEvent'>订阅：上下线通知</el-checkbox>
          <span class='ws-status' :class='wsConnected ? "status-ok" : "status-off"'>
            <i :class='wsConnected ? "el-icon-success" : "el-icon-warning-outline"' />
            {{ wsConnected ? 'WS 已连接' : 'WS 未连接' }}
          </span>
        </div>
      </el-card>
      <br>

      <!-- 在线人员网格 -->
      <div class='online-box'>
        <div class='online-toolbar'>
          <el-input
            v-model='keyword'
            placeholder='搜索昵称'
            prefix-icon='el-icon-search'
            clearable
            size='small'
            class='search-input' />
          <span v-if='filteredUsers.length > showLimit && !showAll' class='show-all-hint'>
            共 <b>{{ filteredUsers.length }}</b> 人，当前仅展示前 {{ showLimit }} 人
            <el-link type='primary' @click='showAll = true'>显示全部</el-link>
          </span>
        </div>

        <div v-for='item in displayedUsers' :key='item.id' class='user_box' @click.stop='jumpToDetail(item)'>
          <el-tooltip class='item' effect='dark' placement='top'>
            <div slot='content'>
              用户：{{ item.nickname }}<br>浏览器：{{ item.browser }}<br>设备：{{ item.device }}<br>系统：{{ item.platform }}<br>
              IP：{{ item.ip }}<br>在线时间：{{ item.login_at || '-' }}
            </div>
            <div v-if='item' class='users donghua'>
              <div class='user_avatar'>
                <el-image
                  lazy
                  :src='item.avatar || avatar'
                  height='50px'
                  width='50px'
                  style='border-radius: 50%;margin: 0 auto;display: block;cursor: pointer'
                  @click.stop='openDetail(item)' />
              </div>
              <div class='user_info'>
                <span class='user_text' @click.stop='openDetail(item)'>
                  <el-link class='el-icon-close' style='width: 10px;margin-right: 2px' type='primary' @click.stop='handleOutline' />
                  {{ item.nickname || '未知' }}
                </span>
              </div>
            </div>
          </el-tooltip>
        </div>

        <el-empty v-if='!displayedUsers.length' description='暂无在线人员' :image-size='80' />
      </div>    
      <!-- 上线 / 下线记录 -->
      <div class='record-row'>
        <div class='show-staff'>
          <div class='panel-title panel-online'>上线记录（{{ onlinePairs.length }}）</div>
          <div v-for='(staff, index) in onlinePairs' :key='staff.id'>
            <template v-if='!showStaff || index === showStaff'>
              <el-tag type='success' size='mini' effect='plain'>上线</el-tag>
              {{ staff.nickname }} 第【{{ staff.count || 0 }}】次 ({{ formatSec(staff.sec) }})
              <el-button type='text' size='mini' @click='onlyShow(staff, index)'>仅看Ta</el-button>
            </template>
          </div>
          <el-empty v-if='!onlinePairs.length' description='暂无上线记录' :image-size='50' />
        </div>
        <div class='show-staff'>
          <div class='panel-title panel-outline'>下线记录（{{ outlinePairs.length }}）</div>
          <div v-for='(staff, index) in outlinePairs' :key='staff.id'>
            <template v-if='!showStaff || index === showStaff'>
              <el-tag type='info' size='mini' effect='plain'>下线</el-tag>
              {{ staff.nickname }} 第【{{ staff.count || 0 }}】次 ({{ formatSec(staff.sec) }})
              <el-button type='text' size='mini' @click='onlyShow(staff, index)'>仅看Ta</el-button>
            </template>
          </div>
          <el-empty v-if='!outlinePairs.length' description='暂无下线记录' :image-size='50' />
        </div>
      </div>

      <!-- 监听的事件 -->
      <div >
        <el-divider content-position='left'>
          <el-link @click='getOnEvents'>监听的事件</el-link>
        </el-divider>
        <el-tag v-for='(e, eventName) in eventList' :key='eventName' style='margin: 2px'>{{ eventName }}</el-tag>
        <el-button style='margin-left: 8px' type='text' @click='clearTmp'>清空</el-button>
      </div>
      <br/>
    </div>

  </PageHeaderLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import avatar from '@/assets/avatar.png'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import '@/utils/sys/network.js'

const REGISTER_LIST_EVENT = 'ev_online_list'

export default {
  name: 'OnLine',
  components: {
    PageHeaderLayout
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 昵称关键字过滤
    filteredUsers() {
      const kw = (this.keyword || '').trim().toLowerCase()
      if (!kw) return this.lineArray
      return this.lineArray.filter(u => (u.nickname || '').toLowerCase().indexOf(kw) > -1)
    },
    // 大数据量时仅渲染前 showLimit 个（除非“显示全部”）
    displayedUsers() {
      return this.showAll ? this.filteredUsers : this.filteredUsers.slice(0, this.showLimit)
    },
    onlinePairs() {
      return Object.keys(this.online || {}).map(id => Object.assign({ id }, this.online[id]))
    },
    outlinePairs() {
      return Object.keys(this.outline || {}).map(id => Object.assign({ id }, this.outline[id]))
    }
  },
  data() {
    return {
      avatar: avatar,
      lineArray: [],
      subStatus: true,
      eventList: {}, // 监听的事件列表
      keyword: '',
      showAll: false,
      showLimit: 200,
      showStaff: '',
      online: Object.create(null),
      outline: Object.create(null),
      wsConnected: false,
      refreshing: false,
      autoTimer: null
    }
  },
  mounted() {
    setTimeout(() => {
      // 事件监听 + 订阅
      this.listenerWsEvent()
    }, 1000)
    // 定时器：10s 刷新在线列表，并检测 WS 断线重连
    this.autoTimer = setInterval(() => this.autoRefresh(), 10 * 1000)
    this.autoRefresh()
  },
  beforeDestroy() {
    if (this.autoTimer) {
      clearInterval(this.autoTimer)
      this.autoTimer = null
    }
    this.subStatus = false
    // 取消订阅
    if (this.$globalWs) this.subEvent()
  },
  methods: {
    // 秒 → 人类可读
    formatSec(sec) {
      const s = Number(sec) || 0
      if (s < 60) return `${Math.round(s)}s`
      const m = Math.floor(s / 60)
      const r = Math.round(s % 60)
      return `${m}分${r}秒`
    },
    onlyShow(row, staffId) {
      this.showStaff = staffId
      this.$notify.success(`仅看用户【${row.nickname || ''}】`)
    },
    clearTmp() {
      this.online = Object.create(null)
      this.outline = Object.create(null)
      this.showStaff = ''
    },
    // 定时刷新 / 断线重连检测
    autoRefresh() {
      let connected = false
      try {
        // $globalWs.ws 是 webSocket 封装实例；其 .ws 才是原生 WebSocket
        const native = this.$globalWs && this.$globalWs.ws && this.$globalWs.ws.ws
        connected = !!(native && native.readyState === 1) // WebSocket.OPEN === 1
      } catch (e) {
        connected = false
      }
      const reconnected = connected && !this.wsConnected
      this.wsConnected = connected
      if (connected) {
        // 断线重连后重新订阅上下线通知（onEvent 回调 map 在封装实例上，重连后仍有效）
        if (reconnected) this.subEvent()
        // 定时拉取在线列表（send 内部会校验 readyState，未连接自动忽略）
        this.subOnlineList()
      }
    },
    // 订阅在线用户列表
    subOnlineList() {
      if (this.$globalWs && this.$globalWs.ws) this.$globalWs.subEvt('get_online_users')
    },
    // 订阅/取消订阅 上下线通知
    subEvent() {
      if (!this.$globalWs || !this.$globalWs.ws) {
        this.$notify.warning('WebSocket服务尚未连接成功')
        return false
      }
      if (this.subStatus) {
        this.$globalWs.subEvt('subscribe_logout')
        this.$globalWs.subEvt('subscribe_login')
        // 事件监听-用户下线
        this.$globalWs.onEvt('ev_logout', (msg, data) => {
          if (msg === 'success' && data && data.id) {
            const now = Date.now()
            const staffId = data.id
            if (!this.outline[staffId]) {
              this.$set(this.outline, staffId, { nickname: data.nickname, count: 1, time: now, sec: 0 })
            } else {
              const rec = this.outline[staffId]
              rec.sec += Math.max(0, (now - rec.time) / 1000) // 单位：秒
              rec.count += 1
              rec.time = now
              this.$set(this.outline, staffId, rec)
            }
            const index = this.lineArray.findIndex(v => v.id === data.id)
            if (index > -1) this.lineArray.splice(index, 1)
          }
        })
        // 事件监听-用户上线
        this.$globalWs.onEvt('ev_login', (msg, data) => {
          if (msg === 'success' && data && data.id) {
            const now = Date.now()
            const staffId = data.id
            if (!this.online[staffId]) {
              this.$set(this.online, staffId, { nickname: data.nickname, count: 1, time: now, sec: 0 })
            } else {
              // 修复：原实现误写 this.outline，导致“第N次上线”永不递增
              const rec = this.online[staffId]
              rec.sec += Math.max(0, (now - rec.time) / 1000)
              rec.count += 1
              rec.time = now
              this.$set(this.online, staffId, rec)
            }
            const index = this.lineArray.findIndex(v => v.id === data.id)
            if (index === -1) this.lineArray.unshift(data)
          }
        })
      } else {
        this.$globalWs.subEvt('cancel_subscribe_logout')
        this.$globalWs.subEvt('cancel_subscribe_login')
        this.$globalWs.rmEvt('ev_login')
        this.$globalWs.rmEvt('ev_logout')
      }
    },
    // 事件监听-在线列表
    listenerWsEvent() {
      if (this.$globalWs && this.$globalWs.ws) {
        this.$globalWs.onEvt(REGISTER_LIST_EVENT, (msg, data) => {
          if (msg === 'success') this.lineArray = data || []
        })
      }
      this.subOnlineList()
      this.subEvent()
    },
    forceClear() {
      this.lineArray = []
      if (this.$globalWs && this.$globalWs.ws) this.$globalWs.sendMsg({ event: 'force_clear_online' })
    },
    refreshOnline() {
      this.refreshing = true
      this.lineArray = []
      if (this.$globalWs && this.$globalWs.ws) this.$globalWs.sendMsg({ event: 'clear_online' })
      setTimeout(() => {
        this.subOnlineList()
        this.refreshing = false
      }, 500)
    },
    getOnEvents() {
      this.eventList = (this.$globalWs && this.$globalWs.getOnEvents) ? this.$globalWs.getOnEvents() : {}
    },
    returnList() {
      this.$router.push(this.$route.matched[1].path)
    },
    jumpToPage(pageName, params) {
      this.$router.push({ name: pageName, params })
    },
    jumpToDetail(row) {
      if (row && row.id) this.jumpToPage('UserDetail', { user_id: row.id })
    },
    // 点击头像：在新标签页打开用户详情
    openDetail(row) {
      if (row && row.id) {
        const { href } = this.$router.resolve({ name: 'UserDetail', params: { user_id: row.id } })
        window.open(href, '_blank')
      }
    },
    handleOutline() {
      this.$notify.info('强制下线功能开发中....')
    }
  }
}
</script>

<style scoped>
.online-box {
  width: 98%;
  border: none;  
  padding: 20px;
  margin: auto;
  text-align: left;
  overflow: auto;
  min-height: 500px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: flex-start;
}

.online-toolbar {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.search-input {
  width: 220px;
}

.show-all-hint {
  margin-left: 12px;
  color: #909399;
  font-size: 13px;
}

.user_box {
  width: 100px;
  float: left;
}

.users {
  margin: 0 auto;
  display: block;
  cursor: pointer;
}

.user_avatar {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  text-align: center;
  margin: 0 auto;
}

.user_info {
  width: 100%;
  height: 30px;
  margin-top: 10px;
}

.user_text {
  display: block;
  text-align: center;
  font-size: 12px;
  color: black;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.header-title {
  font-weight: bold;
  font-size: 18px;
  margin: 0 12px;
}

.ws-status {
  margin-left: 16px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
}

.ws-status i {
  margin-right: 4px;
  font-size: 14px;
}

.status-ok {
  color: #67C23A;
}

.status-off {
  color: #E6A23C;
}

/* 记录面板 */
.record-row {
  gap: 10px;
  margin-top: 10px;
  display: flex;
}

.show-staff {
  height: 500px;
  overflow-y: scroll;
  width: 500px;
  margin: 5px;
  border: #f2f2f2 1px solid;
  padding: 10px;
  border-radius: 5px;

}

.panel-title {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 14px;
}

.panel-online {
  color: #67C23A;
}

.panel-outline {
  color: #909399;
}

/* 定义关键帧 */
@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 应用动画到元素 */
.donghua {
  animation: fadeInOut 2s 1;
}
</style>
